export default __webpack_public_path__ + "static/media/redtag.81128007.svg";